export enum Tiers {
    'Tier 0' = 0,
    'Tier 1' = 1,
    'Tier 2' = 2,
    'Tier 3' = 3,
  }
  